import { URL_PATTERN } from "constant/app";
import { webPageToMediaEntry } from "fleet/view/media-library/utils";
import { PropTypePriorities } from "fleet/view/strategy-v2/utils";
import PropTypes from "prop-types";
import React from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import FormLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Row from "react-bootstrap/Row";
import { Notification } from "ui/notification";

class AddWebPageForm extends React.PureComponent {
  static get propTypes() {
    return {
      addSpots: PropTypes.func,
      priority: PropTypePriorities.isRequired,
    };
  }

  static get defaultProps() {
    return {
      addSpots: () => {},
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      webPage: {
        name: "",
        url: "",
        duration: 15,
      },
      errorMessage: "",
      successMessage: "",
    };

    this._addWebPage = this._addWebPage.bind(this);
    this._durationChange = this._onChange.bind(this, "duration");
    this._nameChange = this._onChange.bind(this, "name");
    this._urlChange = this._onChange.bind(this, "url");
  }

  _isValidUrl(userInput) {
    return URL_PATTERN.test(userInput);
  }

  _getFormErrors(webPage) {
    const { name, url, duration } = webPage;
    const numDuration = Number(duration);

    if (!name) {
      return "Name cannot be blank!";
    }

    if (!url) {
      return "Url cannot be blank!";
    }

    if (!this._isValidUrl(url)) {
      return "Please provide a valid url.";
    }

    if (isNaN(numDuration) || numDuration < 0) {
      return "Duration must be greater than 0 seconds.";
    }

    return false;
  }

  _addWebPage() {
    const { priority, addSpots } = this.props;
    const { webPage } = this.state;

    const formError = this._getFormErrors(webPage);
    if (formError) {
      this.setState({
        errorMessage: formError,
        successMessage: "",
      });

      return;
    }

    const spots = [webPageToMediaEntry(webPage)];

    const payload = {
      priority,
      spots,
    };

    addSpots(payload);

    this.setState({
      errorMessage: "",
      successMessage: "Success! Web page added to strategy.",
    });
  }

  _onChange(propName, e) {
    const { webPage } = this.state;
    const { value } = e.target;

    this.setState({
      ...this.state,
      webPage: {
        ...webPage,
        [propName]: value,
      },
    });
  }

  render() {
    const { webPage, errorMessage, successMessage } = this.state;
    const { duration, name, url } = webPage;

    return (
      <div>
        <Row>
          <Col xs={12}>
            <Notification success={successMessage} error={errorMessage} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <FormLabel>Name</FormLabel>
              <FormControl
                type="text"
                placeholder="My Great Website"
                required={true}
                defaultValue={name}
                onChange={this._nameChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <FormGroup>
              <FormLabel>URL</FormLabel>
              <FormControl
                type="url"
                placeholder="https://www.vistarmedia.com"
                required={true}
                defaultValue={url}
                onChange={this._urlChange}
              />
            </FormGroup>
          </Col>
          <Col xs={4}>
            <FormGroup>
              <FormLabel>Duration (in seconds)</FormLabel>
              <FormControl
                type="number"
                min="0"
                placeholder="Duration (seconds)"
                required={true}
                defaultValue={duration}
                onChange={this._durationChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button
              variant="success"
              className="add-content pull-right"
              title="Add this web page to your strategy"
              onClick={this._addWebPage}
            >
              <i className="fa fa-plus" aria-hidden="true" />
              {" Add to Strategy"}
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export { AddWebPageForm };
